import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import Cookies from 'js-cookie'
import locale from 'element-ui/lib/locale'  //引入elementuiui语言包模块
import elementEnLocale from 'element-ui/lib/locale/lang/en'  // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'  // element-ui lang
import enLocale from './en'
import zhLocale from './zh'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  }
}
export function getLanguage() {

  const chooseLanguage = localStorage.getItem('language')

  console.log('lang:'+chooseLanguage);
  if (chooseLanguage) return chooseLanguage

  //根据浏览器语言选择
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      if (locale === 'zh' || locale === 'en') {
        console.log('locale:'+locale)
        return locale
      }
    }
  }

  return 'en'
}
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages
});

locale.i18n((key, value) => i18n.t(key, value));

export default i18n
